<template>
  <div class="chat-text">
    <div v-if="tweenStarted" ref="container" class="leaves">
      <div class="dot" v-for="(dot, index) in total" :key="index">
        {{ startTween(index) }}
      </div>
    </div>
    <div class="messages" ref="messages" id="messages">
      <!-- <Message /> -->
      <div
        class="message dont-break-out"
        v-for="(messageData, index) in sessionChat"
        :key="index"
      >
        <div
          :class="
            messageData.UID === userID
              ? 'localDateTimeDisplay'
              : 'dateTimeDisplay'
          "
        >
          {{ returnHoursMinutes(messageData.dateMS) }}
        </div>

        <div
          :class="
            messageData.UID === userID
              ? 'localMessageContent'
              : 'messageContent'
          "
        >
          <div
            :class="
              messageData.UID === userID ? 'localDisplayName' : 'displayName'
            "
          >
            {{ getDisplayName(messageData.UID) }}
          </div>
          <div
            v-html="autolinkedMessage(messageData)"
            :class="
              messageData.UID === userID ? 'localMessageText' : 'messageText'
            "
          ></div>
        </div>
      </div>
    </div>
    <!-- <img :src="box" @click="popMystery" class="mystery" /> -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import box from "../../../assets/images/box.png";
import gsap from "gsap";

import Autolinker from "autolinker";

import { format } from "date-fns";
// Chat.vue is a SIGNALER;

const autolinkerOptions = {
  urls: {
    schemeMatches: true,
    wwwMatches: true,
    tldMatches: true,
  },
  email: false,
  phone: false,
  mention: false,
  hashtag: false,

  stripPrefix: true,
  stripTrailingSlash: true,
  newWindow: true,

  truncate: {
    length: 0,
    location: "end",
  },

  className: "messageTextLink",
};

export default {
  name: "FloatingChatMessages",
  props: {
    user: Object,
    partnerMetadata: Object,
  },
  data() {
    return {
      //   userIsAttemptingJoin: false,

      total: 30,
      w: window.innerWidth,
      h: window.innerHeight,
      tweenStarted: false,

      box: box,

      userCurrentChatText: "",
      typing: false,
      connections: 0,
    };
  },
  computed: {
    userID: function () {
      return this.user._id;
    },
    ...mapState({
      sessionChat: (state) => state.session.sessionChat,
    }),
  },
  mounted() {
    this.scrollChatToBottom();
  },
  methods: {
    autolinkedMessage(messageData) {
      return Autolinker.link(messageData.msg, autolinkerOptions);
    },
    getDisplayName(UID) {
      if (UID === this.user._id) return this.user.displayName;
      return this.partnerMetadata ? this.partnerMetadata.displayName : null;
    },
    startTween(index) {
      this.$nextTick(function () {
        let childTween = this.$refs.container.children[index];
        gsap.set(childTween, {
          x: this.R(0, this.w),
          y: this.R(-200, -150),
          z: this.R(-200, 200),
        });
        this.animm(childTween);
      });
    },
    animm(elm) {
      gsap.to(elm, this.R(6, 15), {
        y: this.h + 100,
        ease: gsap.easeNone,
        repeat: -1,
        delay: -15,
      });
      gsap.to(elm, this.R(4, 8), {
        x: "+=100",
        rotationZ: this.R(0, 180),
        repeat: -1,
        yoyo: true,
        ease: gsap.easeInOut,
      });
      gsap.to(elm, this.R(2, 8), {
        rotationX: this.R(0, 360),
        rotationY: this.R(0, 360),
        repeat: -1,
        yoyo: true,
        ease: gsap.easeInOut,
        delay: -5,
      });
    },
    R(min, max) {
      return min + Math.random() * (max - min);
    },
    popMystery() {
      /* a Pen by Diaco m.lotfollahi  : https://diacodesign.com */
      // var falling = true;
      this.tweenStarted = true;
      this.$nextTick(function () {
        let container = this.$refs.container;
        gsap.set(container, { perspective: 600 });
      });
      // TweenLite.set("img", { xPercent: "-50%", yPercent: "-50%" });
    },
    returnHoursMinutes(dateTime) {
      return format(dateTime, "hh:mmaaaaa'm'");
    },
    scrollChatToBottom() {
      //   let chatMessages = this.$refs.messages;
      let chatMessages = document.getElementById("messages");
      chatMessages.scrollTop = chatMessages.scrollHeight;
      //   chatMessages.scrollIntoView(false);
    },
  },
  watch: {
    sessionChat: function () {
      let globalThis = this;
      globalThis.$nextTick(() => {
        globalThis.scrollChatToBottom();
      });
    },
  },
};
</script>

<style scoped>
.chat-text {
  color: #222;
  flex: 1;
  height: 64%;
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
}

.displayName {
  color: #7b7b7b;
  font-size: 12px;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.messageContent {
  padding: 10px;
  border-radius: 6px;
  width: 70%;
  background-color: rgb(255 255 255);
}

.localMessageContent {
  padding: 10px;
  border-radius: 6px;
  width: 70%;
  margin-left: auto;
  background-color: rgb(255 255 255);
}

.messages {
  flex: 1;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  margin: 10px;
  padding: 0px 4px;
  padding-top: 10px;
}

.message {
  padding: 5px 7px;
  position: relative;
}

.localDisplayName {
  color: #7b7b7b;
  font-size: 12px;
  text-align: right;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  white-space: nowrap;
  position: relative;
}

.messageText {
  font-size: 17px;
  padding: 6px 0 2px 0px;
  color: #222;
  box-sizing: border-box;
  white-space: break-spaces;
  display: inline-block;
}

/*
THIS MUST BE GLOBAL STYLE TO WORK WITH AUTO-LINKER TO PRODUCE LINKS
.messageTextLink {
  color: #1f3058;
  text-decoration: underline;
}

.messageTextLink:hover {
  color: blue;
} */

.localMessageText {
  font-size: 17px;
  padding: 6px 0 2px 0px;
  color: #222;
  text-align: start;
  box-sizing: border-box;
  white-space: break-spaces;
  display: inline-block;
}

.dateTimeDisplay,
.localDateTimeDisplay {
  position: absolute;
  font-size: 11px;
  right: 14px;
  font-weight: 600;
  color: #7b7b7b;
  align-items: inherit;
  text-align: right;
  padding: 2px;
  z-index: 999;
  max-width: 212px;
  border-radius: 5px;
  opacity: 0;
  transition: opacity 0.1s ease-out 0s;
  transition-delay: 0s;
  top: 50%;
  /* center vertically */
  transform: translateY(-50%);
}

.localDateTimeDisplay {
  right: 80%;
  left: unset;
}

.dateTimeDisplay {
  left: 80%;
  right: unset;
}

.message:hover .dateTimeDisplay,
.message:hover .localDateTimeDisplay {
  opacity: 1;
  transition: opacity 0.1s ease-out 0s;
  transition-delay: 0.4s;
}

.mystery {
  width: 24px;
  height: 24px;
  position: absolute;
  bottom: 20px;
  right: 100px;
  transition: 0.1s ease-in-out;
}

.mystery:hover {
  /* transform: scale(1.04); */
  transform: rotate(25deg) scale(1.08);
  cursor: pointer;
}

.leaves {
  z-index: 9999;
}
/* 
.dot {
  background-color: green;
  width: 25px;
  height: 25px;
  z-index: 9999;
} */

body {
  background-color: #111;
  font-family: Signika Negative, Asap, sans-serif;
  color: white;
  overflow: hidden;
}
.dot {
  width: 35px;
  height: 35px;
  position: absolute;
  background: url(http://www.clipartqueen.com/image-files/red-lobed-fall-clipart-leaf.png);
  background-size: 100% 100%;
}
html,
body,
#container {
  width: 100%;
  height: 100%;
}
#logo {
  left: 50%;
  top: 50%;
  position: absolute;
  border-radius: 10px;
}
</style>